import { Button, Checkbox, Header, Link, Wizard } from '@driftt/dds'
import React, { useState } from 'react'

import {
  FLFormRedirectUrlInput,
  FLFormRedirectUrlInputProps,
} from 'components/Fastlane/shared/FLFormRedirectUrlInput'

import { useFLWizardStore } from '../FLCreationWizard.context'
import { StyledStepContainer } from '../FLCreationWizard.styles'
import { FLCreationWizardStepSidePanel } from '../FLCreationWizardStepSidePanel'

export const FLCreationWizardStepFormConfig = () => {
  const [showAdvancedOptions, setShowAdvancedOptions] = useState(false)
  const [urlError, setUrlError] = useState<string>()
  const {
    store: { redirectUrl, hasRedirect, isDeferredSubmission },
    setStore: setWizardStore,
  } = useFLWizardStore()

  const handleRedirectUrlChange: FLFormRedirectUrlInputProps['onChange'] = ({
    redirectUrl,
    hasRedirect,
    urlError: urlInputError,
  }) => {
    setUrlError(urlInputError)
    setWizardStore((curr) => ({
      ...curr,
      redirectUrl,
      hasRedirect: hasRedirect,
      isDeferredSubmission: hasRedirect ? curr.isDeferredSubmission : false,
    }))
  }

  return (
    <Wizard.Step split="center">
      <StyledStepContainer alignItems="flex-start">
        <Header variant="h3">
          Almost there! Confirm your form&apos;s configuration.
        </Header>
        <FLFormRedirectUrlInput
          disabled={isDeferredSubmission}
          onChange={handleRedirectUrlChange}
          hasRedirect={hasRedirect}
          redirectUrl={redirectUrl}
        />
        {hasRedirect && (
          <>
            <Button
              css={{
                color: '$blue8',
              }}
              variant="tertiary"
              onClick={() => setShowAdvancedOptions((curr) => !curr)}
            >
              {showAdvancedOptions
                ? 'Hide advanced options'
                : 'Show advanced options'}
            </Button>
            {showAdvancedOptions && (
              <>
                <Checkbox
                  label="I want Fastlane to display after the site visitor is redirected."
                  description="This will require a 2-step JavaScript installation process"
                  checked={isDeferredSubmission}
                  onChange={(checked) =>
                    setWizardStore((curr) => ({
                      ...curr,
                      isDeferredSubmission: checked,
                    }))
                  }
                />
                <Link
                  href="https://devdocs.drift.com/docs/fast-lane-playbook-install-guide#deferred-form-submissions"
                  external
                >
                  Learn more about the JavaScript installation process
                </Link>
              </>
            )}
          </>
        )}
        <Wizard.StepActionButton
          disabled={!isDeferredSubmission && hasRedirect && !!urlError}
        />
      </StyledStepContainer>
      <FLCreationWizardStepSidePanel variant="urlWindow" />
    </Wizard.Step>
  )
}
